import * as OM from '@/model';
import * as VM from '@/viewmodel';
import { wsurl } from '@/config';
import { CommonServices } from '@/services/CommonServices';
import { StorageServices } from './StorageServices';

class _WsServices {
    
    private ws: WebSocket;
    
    private _messageListener: (msg: any) => void = () => {};
    private _disableListener: (disable: VM.WsDisableMessage) => void = () => {};
    private _removeListener: (remove: VM.WsRemoveMessage) => void = () => {};
    private _notificationListener: (notification: VM.WsNotificationMessage) => void = () => {};
    private _enableAffiliateAreaListener: (notification: VM.WsNotificationMessage) => void = () => {};
    private _chatRoomIdentifier: string = "";
    private _userIdentifier: string = "";

    SetMessageListeners(messageListener: (msg: any) => void, 
        disableListener: (disable: VM.WsDisableMessage) => void,
        removeListener: (remove: VM.WsRemoveMessage) => void){
        this._messageListener = messageListener;
        this._disableListener = disableListener;
        this._removeListener = removeListener;
    }

    SetNotificationListener(notificationListener: (notification: VM.WsNotificationMessage) => void){
        this._notificationListener = notificationListener;
    }

    SetEnableAffiliateAreaListener(enableAffiliateAreaListener: () => void){
        this._enableAffiliateAreaListener = enableAffiliateAreaListener;
    }

    ConnectSocket(){
        let token = StorageServices.getLoginData()?.token;
        if(!token)
            return;
        this.ws = new WebSocket(wsurl + "?token=" + token);
        this.ws.onopen = (e) => {
            if(this._chatRoomIdentifier && this._userIdentifier){
                this.connectToChatRoom(this._chatRoomIdentifier, this._userIdentifier);
            }
        };
        this.ws.onclose = (e) => {
            this.ws.close();
            setTimeout(() => {
                this.ConnectSocket();
                // this.SetMessageListeners(this._messageListener, this._disableListener, this._removeListener);
                // this.SetNotificationListener(this._notificationListener);
            }, 2000);
        }
        this.ws.onmessage = (wsMsg: MessageEvent) => {
            let data = <VM.WsMessage<any>>JSON.parse(wsMsg.data);
            if(data.type == 'message'){
                this._messageListener(data.content);
            } else if(data.type == 'disable'){
                this._disableListener(data.content);
            } else if(data.type == 'remove'){
                this._removeListener(data.content);
            } else if(data.type == 'notification'){
                this._notificationListener(data.content);
            } else if(data.type == 'enableAffiliateArea'){
                this._enableAffiliateAreaListener(data.content);
            }
        }
    }

    connectToChatRoom(chatRoomIdentifier: string, userIdentifier: string){
        this._chatRoomIdentifier = chatRoomIdentifier;
        this._userIdentifier = userIdentifier;
        let msg = new VM.WsMessage<VM.WsConnectToChatRoom>();
        msg.type = "WsConnectToChatRoom";
        msg.content = new VM.WsConnectToChatRoom();
        msg.content.chatRoomIdentifier = chatRoomIdentifier;
        msg.content.userIdentifier = userIdentifier;
        this.ws.send(JSON.stringify(msg));
    }

    leaveChatRoom(chatRoomIdentifier: string, userIdentifier: string){
        let msg = new VM.WsMessage<VM.WsLeaveChatRoom>();
        msg.type = "WsLeaveChatRoom";
        msg.content = new VM.WsLeaveChatRoom();
        msg.content.chatRoomIdentifier = chatRoomIdentifier;
        msg.content.userIdentifier = userIdentifier;
        this.ws.send(JSON.stringify(msg));
        this._messageListener = () => {};
        this._disableListener = () => {};
        this._removeListener = () => {};
    }

    SendMessage(message: VM.SendMessageVm){
        let msg = new VM.WsMessage();
        msg.type = "message";
        msg.content = message;
        this.ws.send(JSON.stringify(msg));
    }

    Disconnect(){
        this.ws.onclose = () => {};
        this.ws.close();
    }
}

export let WsServices = new _WsServices();